// Dependencies
import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

import {
  BackImage,
  CheckLogin,
  Header,
  NotFoundView,
  NotLoggedInView,
  Navbar,
} from 'C4';

const loginPages = ['training', 'retain'];
const paths = `(${loginPages.join('|')})`;

const SubRouter = () => (
  <div className="subRouter" id="container">
    <Route path={`/main/${paths}`} render={() => <CheckLogin />} />
    <Route
      path="/main/"
      render={(routerProps) => {
        const { pathname } = routerProps.location;
        // if (pathname === '/main/breakout-sessions' || pathname === '/main' || pathname === '/' || pathname === '/main/landing' || pathname === '/main/sell/neighborhood-videos') {
        //   return '';
        // }
        if (pathname.includes('/main/exhibition/')) {
          return (<Header pathname={pathname} />);
        }
        if (pathname.includes('main/training/chapter/')) {
          return (<Header pathname={pathname} />);
        }
        return (<Navbar pathname={pathname} />);
      }}
    />
    <div className="viewContainer">
      <BackImage darken={(window.location.pathname !== '/main') && (window.location.pathname !== '/main/')} />
      <Switch>
        <Route path="/main/off" component={NotLoggedInView} />
        <Route component={NotFoundView} />
      </Switch>
    </div>
    {/* <Footer /> */}
  </div>
);

export default withRouter(SubRouter);
